export enum EmployeeEventType {
    Delete = 1
}